// extracted by mini-css-extract-plugin
export default {"icon-button":"IconButton_icon-button__OCZOw","icon":"IconButton_icon__RHegW"};